module.exports = __webpack_public_path__ + "static/media/BAOptionsDropdown.4a1cb093.svg";